(function() {
  angular.module('registration')
    .controller('confirmationController', ['$scope', '$q', 'registrationUserService', '$log', '$state', 'UserEmail', '$translate',
      function ($scope, $q, registrationUserService, $log, $state, UserEmail, $translate) {
        var vm = this;
        vm.resend = resend;
        vm.reset = reset;
        vm.model = registrationUserService.createUserModel();
        vm.email = vm.model.unverifiedEmail;

        if (!vm.model.userSaved && !angular.debug) {
          $state.go('registration.nonDso');
        }
        var unwatch = $scope.$watch('errorControl', function () {
          $scope.errorControl && ($scope.errorControl.hideErrors() || unwatch());
        });

        function resend() {
          $scope.errorControl.showErrors();
          if ($scope.emailForm.$valid) {
            var userData = {
              unverifiedEmail: vm.model.unverifiedEmail,
              userId: vm.model.userId
            };
            UserEmail().updateEmail(userData, function (data) {
              let messageKey = 'content.registration.emailConfirmation';
              if (vm.email === vm.model.unverifiedEmail) {
                messageKey = 'content.registration.resendEmailConfirmation';
              }
              $translate(messageKey).then(function (msg) {
                $scope.msg = msg;
                $scope.dnConfirmationMessage.$show($scope.msg);
                vm.email = vm.model.unverifiedEmail;                
              });
            });
          }
        }

        function reset() {
          vm.model.unverifiedEmail = '';
          $scope.errorControl.hideErrors();
        }
      }]);
})();
